import GetReferentsRequestModel from '../../../generated/types/model/request/GetReferentsRequestModel';

export default class GetReferentsRequestViewModel extends GetReferentsRequestModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
